module.exports = __webpack_public_path__ + "static/media/notification_hubs.a51dc07c.svg";